import { render, staticRenderFns } from "./DefinitionListDialog.vue?vue&type=template&id=7b203bb4&scoped=true&"
import script from "./DefinitionListDialog.vue?vue&type=script&lang=js&"
export * from "./DefinitionListDialog.vue?vue&type=script&lang=js&"
import style0 from "./DefinitionListDialog.vue?vue&type=style&index=0&id=7b203bb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b203bb4",
  null
  
)

export default component.exports